var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.resales-not-review'),"name":"resalesNotReview","url":_vm.$listRoutes.resalesWaitingReview,"table":_vm.resalesNotReview,"filters":_vm.resalesNotReviewFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }